import BlocksRenderer from '@/components/blocks/blocks-renderer';
import LocalMenu from '@/components/local-menu';
import Metadata from '@/components/metadata';
import Hero from '@/components/stories/hero';
import RelatedStories from '@/components/stories/related-stories';
import { getStory } from '@/lib/datocms/story';
import { GetServerSidePropsContext } from 'next';

export default function StoriesPage({ data }: { data: any }) {
  return (
    <>
      <Metadata data={data} />
      <LocalMenu title={data?.page?.title} />
      <Hero data={data?.page} />
      <div style={{ height: 40 }} />
      <BlocksRenderer blocks={data?.page?.blocks} />
      {data?.page?.relatedStories && <RelatedStories data={data?.page?.relatedStories} />}
    </>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { slug } = context.params as { slug: string };
  const locale = context.locale || 'en';

  const data = await getStory(locale, slug);

  return {
    props: { data },
  };
}
